/**
* @name: xm-down-temp
* @author: weiyong
* @date: 2024-01-30 19:49
* @description：xm-down-temp
* @update: 2024-01-30 19:49
*/
<template>
  <div @click="downFileTemp" class="common-link">
    <span class="remix-icon ri-tuichu"></span>
    <span>模版下载</span>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xm-down-temp",
});
</script>

<script lang="ts" setup>
import {getFileList} from "@/components/fileCtl/api/file";
import {QueryCommand} from "xmgoing-server";

interface propTypes {
  tepFileName: string,
  tableCode: string,
  downUrl: string,
  fileTempDownUrl: string,
}

const props = withDefaults(defineProps<propTypes>(), {
  fileTempDownUrl: '',
})
const {fileTempDownUrl} = toRefs(props);

/**
 * 下载模版文件
 */
const downFileTemp = function () {
  //如果定义了模版下载id 则根据模版下载id 进行下载操作
  if (unref(fileTempDownUrl)) {
    //获取附件id
    const busIdDown = unref(fileTempDownUrl);
    //获取附件信息
    const loadFileByDownBusId = async function () {
      const res = await getFileList(busIdDown);
      if (res && res.records && Array.isArray(res.records) && res.records.length > 0) {
        const fileObj = res.records[0];
        const queryCommand = new QueryCommand({});
        //执行导出操作
        queryCommand.executeExport(
          `/api/pe-attachment/attachment/download/` + fileObj.id,
          fileObj.fileName,
          {}
        );
      }
    }
    //加载附件 再进行下载
    loadFileByDownBusId();
  } else {
    const queryCommand = new QueryCommand({showTip: false});
    queryCommand.executeExport(
      props.downUrl || `/api/go-lcc/execute/exportTemplateByTableCode/` + props.tableCode,
      (props.tepFileName || '导入模版') + '.xlsx',
      {}
    );
  }
}

</script>

<style type="text/css" lang="less">

</style>
